import axios from 'axios'

export default () => {
    return {
        sites: '',

        proxy: null,
        api: {
            foundation: '',
            teams: '',
            college: '',
            homes: '',
            marriage: '',
            press: '',
        },

        perPage: 25,
        collection: '',

        siteData: {
            foundation: {
                page: 1,
                finished: false,
                running: false,
            },
            teams: {
                page: 1,
                finished: false,
                running: false,
            },
            college: {
                page: 1,
                finished: false,
                running: false,
            },
            homes: {
                page: 1,
                finished: false,
                running: false,
            },
            marriage: {
                page: 1,
                finished: false,
                running: false,
            },
            retreat: {
                page: 1,
                finished: false,
                running: false,
            },
            press: {
                page: 1,
                finished: false,
                running: false,
            },
        },

        items: [],

        search: null,

        filters: {
            doctype: {
                selected: 'all',
                selections: [],
            },
            index: {
                selected: null,
            },
            sort: {
                selected: 'date_dsc',
            },
        },

        filtered: true,

        aggregatedData: {
            totalAPI: 0,
            finishedAPI: 0,
        },

        finished: false,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted() {
            Object.keys(this.api).forEach((key, value) => {
                let ministry = ''

                if (key !== 'foundation') {
                    ministry = `${key}.`
                }

                this.api[key] = `https://${ministry}${this.proxy}/wp-admin/admin-ajax.php`
            })

            this.fetchInit()
            this.filterInit()
        },

        // π ----
        // :: FETCH INIT ---------------------------::
        // ____
        fetchInit() {
            if (this.sites === 'all') {
                this.fetchAllSites()
            } else if (this.sites === 'foundation') {
                this.fetchEntries(this.api.foundation, this.sites)
            } else if (this.sites === 'teams') {
                this.fetchEntries(this.api.teams, this.sites)
            } else if (this.sites === 'college') {
                this.fetchEntries(this.api.college, this.sites)
            } else if (this.sites === 'homes') {
                this.fetchEntries(this.api.homes, this.sites)
            } else if (this.sites === 'marriage') {
                this.fetchEntries(this.api.marriage, this.sites)
            } else if (this.sites === 'retreat') {
                this.fetchEntries(this.api.retreat, this.sites)
            } else if (this.sites === 'press') {
                this.fetchEntries(this.api.press, this.sites)
            }
        },

        openGrid() {
            const open = gsap.timeline()

            open.to(this.$refs.cardGrid, {
                duration: 0.5,
                height: this.$refs.cardGrid.scrollHeight,
                ease: 'quint.inOut',
            }).to(
                this.$refs.gridCover,
                {
                    duration: 0.3,
                    autoAlpha: 0,
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0.3',
            )
        },

        closeGrid() {
            const close = gsap.timeline()
            close.to(this.$refs.gridCover, { duration: 0.3, autoAlpha: 1 }).to(
                this.$refs.cardGrid,
                {
                    duration: 0.5,
                    height: 180,
                    ease: 'quint.inOut',
                    onComplete: () => ScrollTrigger.refresh(),
                },
                '<0',
            )
        },

        // π ----
        // :: FETCH ENTRIES ---------------------------::
        // ____
        fetchEntries(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName)

            requestData.append('action', 'resourceFetch')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_doctype', this.filters.doctype.selected)
            if (this.filters.index.selected && !this.search) {
                requestData.append('filter_index', this.filters.index.selected)
            }
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }

            this.anyMore(apiURL, apiName)

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    if (response.data.entries != '') {
                        const entries = response.data.entries

                        if (this.filtered) {
                            this.items = entries
                            this.filtered = false
                        } else {
                            const mergedItems = this.items.concat(entries)
                            this.items = mergedItems
                        }

                        if (this.sites === 'all') {
                            this.logAPI(apiName)
                        }

                        this.updatePage(apiName)
                    } else {
                        this.finishedFetch(apiName)
                    }

                    setTimeout(() => {
                        this.openGrid()
                    }, 600)
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: FETCH FROM ALL SITES ---------------------------::
        // ____
        fetchAllSites() {
            const APIs = Object.entries(this.api)

            for (const [apiName, siteAPI] of APIs) {
                if (apiName !== 'press') {
                    this.fetchEntries(siteAPI, apiName)
                }
            }
        },

        // π ----
        // :: CHECK IF THERE ARE ANYMORE ENTRIES ---------------------------::
        // ____
        anyMore(apiURL, apiName) {
            const requestData = new FormData()
            const pageNumber = this.getPage(apiName) + 1

            requestData.append('action', 'resourceFetch')
            requestData.append('collection', this.collection)
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_doctype', this.filters.doctype.selected)
            if (this.filters.index.selected && !this.search) {
                requestData.append('filter_index', this.filters.index.selected)
            }
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    if (response.data.entries == '') {
                        this.finishedFetch(apiName)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: GET A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        getPage(site) {
            if (site === 'foundation') {
                return this.siteData.foundation.page
            } else if (site === 'teams') {
                return this.siteData.teams.page
            } else if (site === 'college') {
                return this.siteData.college.page
            } else if (site === 'homes') {
                return this.siteData.homes.page
            } else if (site === 'marriage') {
                return this.siteData.marriage.page
            } else if (site === 'press') {
                return this.siteData.press.page
            }
        },

        // π ----
        // :: UPDATE A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        updatePage(site) {
            if (site === 'foundation') {
                this.siteData.foundation.page += 1
            } else if (site === 'teams') {
                this.siteData.teams.page += 1
            } else if (site === 'college') {
                this.siteData.college.page += 1
            } else if (site === 'homes') {
                this.siteData.homes.page += 1
            } else if (site === 'marriage') {
                this.siteData.marriage.page += 1
            } else if (site === 'press') {
                this.siteData.press.page += 1
            }
        },

        // π ----
        // :: LOG API FOR "ALL" SITES ---------------------------::
        // ____
        logAPI(currentAPI) {
            if (currentAPI === 'foundation' && this.siteData.foundation.running === false) {
                this.siteData.foundation.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'teams' && this.siteData.teams.running === false) {
                this.siteData.teams.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'college' && this.siteData.college.running === false) {
                this.siteData.college.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'homes' && this.siteData.homes.running === false) {
                this.siteData.homes.running = true
                this.aggregatedData.totalAPI += 1
            } else if (currentAPI === 'marriage' && this.siteData.marriage.running === false) {
                this.siteData.marriage.running = true
                this.aggregatedData.totalAPI += 1
            }
        },

        // π ----
        // :: FINISHED FETCHING ---------------------------::
        // ____
        finishedFetch(finishedAPI) {
            if (this.sites === 'all') {
                this.markComplete(finishedAPI)
            } else {
                this.finished = true
            }
        },

        // π ----
        // :: MARK API AS COMPLETED ---------------------------::
        // ____
        markComplete(finishedAPI) {
            if (finishedAPI === 'foundation' && this.siteData.foundation.finished === false) {
                this.siteData.foundation.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'teams' && this.siteData.teams.finished === false) {
                this.siteData.teams.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'college' && this.siteData.college.finished === false) {
                this.siteData.college.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'homes' && this.siteData.homes.finished === false) {
                this.siteData.homes.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'marriage' && this.siteData.marriage.finished === false) {
                this.siteData.marriage.finished = true
                this.aggregatedData.finishedAPI += 1
            } else if (finishedAPI === 'press' && this.siteData.press.finished === false) {
                this.siteData.press.finished = true
                this.aggregatedData.finishedAPI += 1
            }

            this.allDone()
        },

        // π ----
        // :: ALL DONE? ---------------------------::
        // ____
        allDone() {
            if (this.aggregatedData.finishedAPI === this.aggregatedData.totalAPI) {
                this.finished = true
            }
        },

        // π ----
        // :: FILTER INIT ---------------------------::
        // ____
        filterInit() {
            let api

            if (this.sites === 'all') {
                this.fetchAllFilters()
            } else if (this.sites === 'foundation') {
                api = this.api.foundation
            } else if (this.sites === 'teams') {
                api = this.api.teams
            } else if (this.sites === 'college') {
                api = this.api.college
            } else if (this.sites === 'homes') {
                api = this.api.homes
            } else if (this.sites === 'marriage') {
                api = this.api.marriage
            } else if (this.sites === 'press') {
                api = this.api.press
            }

            /* :: Load Filters Based on Selected Collection
            {+} ---------------------------------- */
            this.fetchFilters(api, 'doctype')
        },

        fetchFilters(apiURL, taxonomy) {
            let filter

            if (taxonomy === 'doctype') {
                filter = this.filters.doctype.selections
            }

            const requestData = new FormData()

            requestData.append('taxonomy', taxonomy)
            requestData.append('action', 'resourcesTaxonomies')

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].name) {
                                filter.push(response.data[i])
                            }
                        }
                    } else {
                        console.log(`There was NO Taxonomy Response`)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        fetchAllFilters() {
            const APIs = Object.values(this.api)

            for (const siteAPI of APIs) {
                this.fetchFilters(siteAPI, 'location')
            }
        },

        // π ----
        // :: FILTER COLLECTION ---------------------------::
        // ____
        /**
         * Once a filter is selected, we need to bind that slug to the appropriate _filter_.
         * Then re-fetch items the filters set through _fetchInit()_.
         */
        filterCollection(filterKey, filterSlug) {
            let newFilter = false

            if (filterKey === 'doctype') {
                if (this.filters.doctype.selected !== filterSlug) {
                    newFilter = true
                    this.filters.doctype.selected = filterSlug
                }
            } else if (filterKey === 'index') {
                newFilter = true
            } else if (filterKey === 'sort') {
                if (this.filters.sort.selected !== filterSlug) {
                    newFilter = true
                    this.filters.sort.selected = filterSlug
                }
            }

            if (newFilter) {
                this.updateResults()
            }
        },

        updateResults() {
            this.closeGrid()
            setTimeout(() => {
                this.resetCollection()
                this.filtered = true
                this.fetchInit()
                this.pushUrlFilters()
            }, 600)
        },

        // π ----
        // :: SET URL FILTERS ---------------------------::
        // ____
        pushUrlFilters() {
            if (history.pushState) {
                const root = `${window.location.protocol}//${window.location.host}${window.location.pathname}?`

                /* :: Doctype
                {+} ---------------------------------- */
                let doctype = `doctype=${this.filters.doctype.selected}`

                /* :: Index
                {+} ---------------------------------- */
                let index = ''
                if (this.filters.index.selected) {
                    index = `index=${this.filters.index.selected}`
                }

                /* :: Sort
                {+} ---------------------------------- */
                let sort = ''
                if (this.filters.sort.selected) {
                    sort = `sort=${this.filters.sort.selected}`
                }

                const divider01 = index ? '&' : ''

                const updatedURL = `${root}${doctype}${divider01}${index}`

                window.history.pushState({ path: updatedURL }, '', updatedURL)
            }
        },

        // π ----
        // :: RESET ---------------------------::
        // ____
        /**
         * Resets the _items_ array and each site's _page_
         */
        resetCollection() {
            this.siteData.foundation.page = 1
            this.siteData.teams.page = 1
            this.siteData.college.page = 1
            this.siteData.homes.page = 1
            this.siteData.marriage.page = 1
            this.siteData.retreat.page = 1
            this.finished = false
            this.items = []
        },
    }
}
